import React from "react";
import LoaderGif from '../../../assets/images/Loading.gif'

const FullSaraLoader = () => {
  return (
    <React.Fragment>
      <div className="loader-container">
        <div className="loader">
          <img src={LoaderGif} alt="Loading" />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FullSaraLoader;
